import { IRootState } from '../../../store'
import { IDocumentScannerState } from '../store/documentScanner.types'

export const getDocumentScannerSelector = (state: IRootState): IDocumentScannerState => state.documentScanner
